import { config } from "core/utils";
export function getHeroVariant(hero, ctaVariant) {
    if (ctaVariant) {
        switch (ctaVariant.kind) {
            case "VtmGoLive":
                return config.tracking.vtmGo.live;
            case "VtmGoOnDemand":
                return config.tracking.vtmGo.program;
        }
    }
    return hero.cta ? "Custom call-to-action" : undefined;
}
export function getHeroCategory(hero) {
    switch (hero.type) {
        case "StaticHero":
        case "ProgramDynamicHero":
            return config.tracking.hero.category.program;
        case "CustomDynamicHero":
            return config.tracking.hero.category.custom;
        default:
            return config.tracking.hero.category.other;
    }
}
export function getHeroList(hero) {
    switch (hero.type) {
        case "StaticHero":
        case "ProgramDynamicHero":
            return config.tracking.listNames.programHero;
        case "CustomDynamicHero":
            return config.tracking.listNames.customHero;
        default:
            return config.tracking.listNames.other;
    }
}
